var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEutelsatLogo(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 197.06 44",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#007dba;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "EXE"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M18.46,1A16.78,16.78,0,0,0,1.71,17.75v7.93A19.32,19.32,0,0,0,21,45a21.19,21.19,0,0,0,3-.21L21.88,34.71a7.49,7.49,0,0,1-.82,0A9.08,9.08,0,0,1,12,25.68V17.75a6.5,6.5,0,1,1,13,0v.82L18.8,21,21,31.39l14.18-5.6v-8A16.75,16.75,0,0,0,18.46,1Z",
    transform: "translate(-1.71 -1)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "104.41 12.48 104.41 17.13 98.43 17.13 98.43 31.52 93.13 31.52 93.13 17.13 87.18 17.13 87.18 12.48 104.41 12.48"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "197.06 12.48 197.06 17.13 191.11 17.13 191.11 31.52 185.81 31.52 185.81 17.13 179.83 17.13 179.83 12.48 197.06 12.48"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M77.37,33c5.26,0,9-2.46,9-7.15V13.48H81V25.75c0,1.75-1.75,2.57-3.66,2.6s-3.66-.85-3.66-2.6V13.48h-5.3V25.82C68.41,30.57,72.1,33,77.37,33Z",
    transform: "translate(-1.71 -1)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "132.34 12.48 127.04 12.48 127.04 31.52 140.27 31.52 141.09 26.87 132.34 26.87 132.34 12.48"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M169.13,30.09,168,32.52H162.6l7.69-17.3-.78-1.74H175l8.47,19H178L177,30.09Zm6-4L173,21.34l-2.12,4.75Z",
    transform: "translate(-1.71 -1)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M150.05,19c0-.75,1.78-1.3,4.34-1.3a27,27,0,0,1,5.92.76l.75-4.31a23.88,23.88,0,0,0-6.91-1c-6.35,0-9.43,2.77-9.43,6.12,0,6.46,11.83,5.47,11.83,7.8,0,.95-2,1.47-4.07,1.47a19.78,19.78,0,0,1-7-1.37l-.79,4.41a19.84,19.84,0,0,0,7.56,1.4c5.74,0,9.61-2.43,9.61-6.26C161.85,20.32,150.05,21.38,150.05,19Z",
    transform: "translate(-1.71 -1)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M52.65,21.48l7.45-1.2v-.2c0-1.2-1.64-2.64-3.72-2.64s-3.73,1.41-3.73,2.64v1.4Zm3.76,6.87a16.27,16.27,0,0,0,5.85-1.71l2.25,3.62A14.29,14.29,0,0,1,56.41,33c-5,0-9-3.25-9-7.28V20.11c0-4,4-7.28,9-7.28s9,3.25,9,7.28v3.8l-12.76,2C52.86,27.09,54.39,28.35,56.41,28.35Z",
    transform: "translate(-1.71 -1)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M113.13,21.48l7.45-1.2v-.2c0-1.2-1.64-2.64-3.72-2.64s-3.73,1.41-3.73,2.64Zm3.73,6.87a16.27,16.27,0,0,0,5.84-1.71L125,30.26a14.29,14.29,0,0,1-8.1,2.74c-5,0-9-3.25-9-7.28V20.11c0-4,4-7.28,9-7.28s9,3.25,9,7.28v3.8l-12.75,2C113.3,27.09,114.87,28.35,116.86,28.35Z",
    transform: "translate(-1.71 -1)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEutelsatLogo);
export default __webpack_public_path__ + "static/media/eutelsat-logo.c1faeaf044384ef456d1099d3d21743c.svg";
export { ForwardRef as ReactComponent };